module.exports = __webpack_public_path__ + "static/media/bg2.4de71a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/bg2.png
// module id = 1355
// module chunks = 0